import React, { useEffect, useState } from 'react';
import {URL_WEB_SERVICE_LOCAL_STORAGE} from './constants/general'

import { CategoriesService, ChannelsService} from './actions/HttpCalls'
import { HttpClient } from './actions/HttpClient'

import './Sass/main.sass'
import './Sass/includes/Components/modules/C23.sass'
// import './Sass/includes/Components/modules/countries.sass'
import C23PeopleOrgFilHeader from './Components/Organisms/Personas/C23/index-filtersHead'
import C23PeopleOrg from './Components/Organisms/Personas/C23'
import C23PeopleOrgWithoutFil from './Components/Organisms/Personas/C23/v2-home-WithoutFil'
import C23ByCategoryService from './Components/Organisms/Personas/C23/v3-home-By-CategoryService'
import LineasC23PersonasOrg from './Components/Organisms/Personas/C23/LineasC23PeopleOrg';
import C23OneCardForMonths from './Components/Organisms/Personas/C23OneCardForMonths';

const httpClient = new HttpClient();
const categoriesService = new CategoriesService(httpClient);
const channelsService = new ChannelsService(httpClient);

function App() {

  const [dataCategoriasBk, setDataCategoriasBk] = useState([])
	const [dataChannelsBk, setDataChannelsBk] = useState([])

  const getValuesDefault = async () => {
    if( URL_WEB_SERVICE_LOCAL_STORAGE.indexOf("MS_FE_GUIA_CANALES") > -1 ){
      const channels = await channelsService.getChannelsItems()
      setDataChannelsBk(channels)
      
      const categories = await categoriesService.getCategoriesItems()
      setDataCategoriasBk(categories)

      console.log("channels", channels)
      console.log("categories", categories)
      // console.log("cplanes", cplanes)
    }
	}

  function version() {
    return localStorage.getItem('version_comparador')
  }

  useEffect(() => {
		getValuesDefault();
		// eslint-disable-next-line
	}, [])


  return (
    <div className="App">
      {
        version() === "v4" ? 
        <C23PeopleOrgFilHeader
          dataChannelsBk={dataChannelsBk}
          dataCategoriasBk={dataCategoriasBk}
        />
        :
        version() === "v2" ? 
          <C23PeopleOrgWithoutFil
            dataChannelsBk={dataChannelsBk}
            dataCategoriasBk={dataCategoriasBk}
          />
        : 
        version() === "v3" ? 
          <C23ByCategoryService
            dataChannelsBk={dataChannelsBk}
            dataCategoriasBk={dataCategoriasBk}
          />
        :
        version() === "v5" ?
          <LineasC23PersonasOrg
            dataChannelsBk={dataChannelsBk}
            dataCategoriasBk={dataCategoriasBk}
          />
        : 
        version() === "v6" ?
          <C23OneCardForMonths
            dataChannelsBk={dataChannelsBk}
            dataCategoriasBk={dataCategoriasBk}
          />
        : 
          <C23PeopleOrg
            dataChannelsBk={dataChannelsBk}
            dataCategoriasBk={dataCategoriasBk}
          />
      }
    </div>
  );
}

export default App;
